<script>
  export default {
    data() {
      return {
        ano: (new Date()).getFullYear(),
      }
    },
    methods: {
    }
  }
</script>

<style>
  .verificar {  
    width: 100%;
    padding: 10px 10px;
    display: flex;
    justify-content: center;
    align-content: center;
  }
</style>

<template>
  <div class="animated fadeInDown" >
    <div>
      <div>
        <h1 class="logo-name text-center verificar">
          <img src="/img/logo.png" alt="logo">
        </h1>
      </div>
      
      <router-view></router-view>
      
      <p class="m-t text-white text-center"> <small>Manager &copy; {{ ano }} </small> </p>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/componentes/LayoutVerificarAssinatura.vue